import gql from 'graphql-tag';

const query = gql`
  query SaleProductVariants($promoCode: String) {
    sale {
      productVariants(promoCode: $promoCode) {
        id
        saleProduct {
          id
          name
          price {
            regular {
              amount
              currency
            }
            promo {
              amount
              currency
            }
          }
        }
      }
    }
  }
`;

export default query;
